var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "FileExcel",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-file-excel","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M150.2 0H32v250h189V73.7L150.2 0zm-.2 12.8L205 70h-55V12.8zM212 241H41V9h100v70h71v162z"/>
  <polygon points="100.5,104.5 78.2,104.5 113.9,160.3 78.2,216.1 100.5,216.1 125.1,173.7 149.7,216.1 172,216.1 136.3,160.3 172,104.5 149.7,104.5 125.1,146.9"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/file-excel.svg